import { createContext, use } from "react";

import { MODULES, sectionPermissions } from "@/config/modules";

/**
 * The permission keys the signed-in user holds.
 *
 * A `Set` because membership is the only question ever asked of it, and the
 * catalogue runs to about seventy keys.
 */
export type PermissionSet = ReadonlySet<string>;

/**
 * Every permission in the navigation map.
 *
 * **This is the stub.** M15-5 replaces it with `CurrentUser.permissions` from
 * the API. The provider, the hook and the filtering all stay as they are —
 * the swap is the value passed in, nothing else.
 */
export const ALL_PERMISSIONS: PermissionSet = new Set(
  MODULES.flatMap((module) => module.sections.flatMap(sectionPermissions)),
);

export const PermissionContext = createContext<PermissionSet>(ALL_PERMISSIONS);

export function usePermissions(): PermissionSet {
  return use(PermissionContext);
}

/**
 * Whether the user holds a permission.
 *
 * **Hiding is never the enforcement** (FR-ACL-8, NFR-14). Every route handler
 * and server action calls `requirePermission()` regardless of what this
 * returns — a hidden nav entry is a courtesy, and its URL is still reachable
 * by anyone who types it.
 */
export function can(permissions: PermissionSet, permission: string): boolean {
  return permissions.has(permission);
}
